module.exports = __webpack_public_path__ + "img/villarreal.8581e7d2.png";